import { setupMatchMedia } from "@tamagui/web";
import { matchMedia } from "./matchMedia";
function createMedia(media) {
  setupMatchMedia(matchMedia);
  return media;
}
export {
  createMedia
};
//# sourceMappingURL=createMedia.js.map
